module.exports = __webpack_public_path__ + "nc_static/media/device-settings.0d88635a.svg";